import React from "react";

const Channel = ({
  style = {},
  width = 20,
  className = "",
  color = "currentColor",
  backgroundColor = "none",
  viewBox = "0 0 25 25",
  ...rest
}) => {
  return (
    <svg width={width} viewBox={viewBox} className={className} {...rest}>
      <g fill="none" fillRule="evenodd">
        <path
          fill={color}
          fillRule="nonzero"
          d="M22.5 7.5h-20V5h20v2.5zM20 0H5v2.5h15V0zm5 12.5v10a2.5 2.5 0 0 1-2.5 2.5h-20A2.5 2.5 0 0 1 0 22.5v-10A2.5 2.5 0 0 1 2.5 10h20a2.5 2.5 0 0 1 2.5 2.5zm-7.5 5L10 13.41v8.16l7.5-4.07z"
        />
        <path d="M-3-2h30v30H-3z" />
      </g>
    </svg>
  );
};

export default Channel;
